import TableRow from "@mui/material/TableRow";
import styled from "@emotion/styled";

const TableRowStyled = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: #fff; /* Corrected: Removed quotes */
  }
  &:nth-of-type(even) {
    background-color: #f1f3f4; /* Light shade for even rows */
  }
  & > td {
    color: black;
   font: 400 16px/1.2 Inter, sans-serif ;
   
    font-style: normal;
 
    line-height: 120%; /* Text color for table cells */
  }
`;

export default TableRowStyled;
